module.exports = __webpack_public_path__ + "static/media/driverimg.2918610d.png";